






















import Vue from 'vue'
import Utils from '@/helpers/Utils'
import { BarElInterface } from '@/config/interfaces'

export default Vue.extend({
  name: 'BarEl',

  computed: {
    getActiveBar (): string {
      const width = Utils.round(
        (this.$props.templateItemData.val / this.$props.templateItemData.maxVal) * 100,
        2
      )
      return `width: ${width}%;background-color: ${this.$props.templateItemData.color};`
    }
  },

  props: {
    templateItemData: {
      type: Object as () => BarElInterface,
      required: true
    }
  }
})
